export enum PrimaryNavKey {
  Dashboard,
  Accounts,
  Assets,
  Cfs,
  ManageAccount,
  Weather,
  Reporting,
  Diagnostics,
}
